import { fexGet } from "@/utils/fex"

export const testPromoCode = async ({code}:{code:string})=>{
    try{
        const data = await fexGet("api/promo/"+code)
        return data
    }catch(err){
        return err
    }
}